<template>
  <main class="bg-white text-gray-800">
    <!-- About Section -->
    <section
      class="max-w-6xl mx-auto px-2 py-16 grid md:grid-cols-2 gap-4 items-center"
    >
      <div>
        <p class="text-sm md:text-base leading-relaxed mb-4 lg:px-0 px-4">
          Mshel Construction Limited is building the future with integrity to
          ensure all projects are actualised with precision, innovation, and
          excellence
        </p>
        <p class="text-sm md:text-base leading-relaxed lg:px-0 px-4">
          Over the years, Mshel Construction have overseen projects from
          planning to execution using a detail-oriented approach to ensure
          timely delivery, cost efficiency, and adherence to specifications. A
          team of skilled professionals drives each project by utilising
          advanced technology and modern construction techniques to ensure
          excellence. Integrity, professionalism and client satisfaction remain
          at the core of every development. All activities are tailored to
          guarantee smooth coordination, safety, and durability of every
          construction project. Mshel Construction is an expert in building
          construction, civil engineering, and estate development.
        </p>

        <!-- Mission & Vision -->
        <div class="grid md:grid-cols-2 gap-4 mt-8 lg:px-0 px-4">
          <div class="bg-white shadow-md rounded-xl py-4 px-2 text-center">
            <div
              class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-indigo-100 text-indigo-600 rounded-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <h3 class="font-semibold text-lg mb-2">Our Mission</h3>
            <p class="text-sm">
              To be Nigeria’s best construction company that delivers excellence
              in quality, innovation, and sustainability.
            </p>
          </div>
          <div class="bg-white shadow-md rounded-xl py-4 px-2 text-center">
            <div
              class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-indigo-100 text-indigo-600 rounded-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <h3 class="font-semibold text-lg mb-2">Our Vision</h3>
            <p class="text-sm">
              To deliver high-quality construction within timeline that reflects
              dedication, hope, and professionalism
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 grid-rows-2 gap-4 h-[500px]">
        <img
          src="../assets/images/Construction_6.jpg"
          alt="Home 1"
          class="rounded-2xl w-full h-full object-cover row-span-2"
        />
        <img
          src="../assets/images/B & M_3.jpg"
          alt="Home 2"
          class="rounded-2xl w-full h-full object-cover"
        />
        <img
          src="../assets/images/Construction_14.jpg"
          alt="Home 3"
          class="rounded-2xl w-full h-full object-cover"
        />
      </div>
    </section>

    <!-- Core Values -->
    <section class="bg-gray-100 py-16 text-center">
      <h2 class="text-2xl md:text-3xl font-semibold mb-10">Our Core Values</h2>
      <div class="flex flex-col md:flex-row justify-center gap-8 px-6">
        <div
          class="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">
            Timely<br />Delivery
          </p>
        </div>
        <div
          class="bg-gradient-to-r from-orange-400 to-orange-300 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">
            Cost<br />Effectiveness
          </p>
        </div>
        <div
          class="bg-gradient-to-r from-cyan-400 to-sky-400 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">
            Quality &<br />Excellence
          </p>
        </div>
        <div
          class="bg-gradient-to-r from-yellow to-yellow text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">
            Innovation &<br /> Sustainability
          </p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
